import React from "react";
import { Box, Typography, Stack, Container, useTheme } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import SpeedIcon from "@mui/icons-material/Speed";
import SecurityIcon from "@mui/icons-material/Security";

const features = [
  {
    icon: "/Images/deposit.png",
    label: "Deposits",
    title: "Instant deposits",
    description: "Wide array of deposit methods to fund your account",
  },
  {
      icon: "/Images/second.png",

    label: "Spreads",
    title: "Unmatched spreads",
    description: "Trade with tight and stable spreads, even during market news.",
  },
  {
        icon: "/Images/third.png",

    label: "Support",
    title: "24/7 Live support",
    description: "Receive answers in minutes via phone, live chat or email, in 3 languages.",
  },
  {
      icon: "/Images/fourth.png",

    label: "Withdrawals",
    title: "Instant withdrawals",
    description: "Funds hit your account instantly with our instant withdrawals. T&Cs apply.",
  },
  {
      icon: "/Images/fifth.png",

    label: "Execution speed",
    title: "More speed, less slippage",
    description: "Trade with the most precise execution in the market.",
  },
  {
      icon: "/Images/sixth.png",

    label: "Best-in-security",
    title: "Best-in-class security",
    description: "Trade knowing your funds are kept safe in separated client, with ironclad data protection.",
  },
];

const SmallComponent = () => {
  const theme = useTheme();

  return (
    <Box sx={{ background: "linear-gradient(rgba(28, 44, 65, 1), rgba(3, 19, 40, 1))", pt: 4 }}>
      <Container maxWidth="sm">
        <Typography
          variant="h5"
          textAlign="center"
          color="#fff"
          fontWeight={700}
          sx={{ mb: 1,fontSize:{xs:"27px !important"} }}
        >
          Thrive in the gold, oil, indices, and crypto markets
        </Typography>
        <Typography
          variant="body2"
          textAlign="center"
          color="rgba(255,255,255,0.8)"
          sx={{ mb: 4 }}
        >
          Trading conditions can make or break a strategy, that’s why you need the best.
        </Typography>

        <Stack spacing={4} textAlign="center">
          {features.map((feature, index) => (
            <Box key={index}>
              <Box
              mb={1}
                // display="inline-flex"
                // alignItems="center"
                // gap={1}
                // // bgcolor="#0B3A75"
                // // color="#fff"
                // px={2}
                // py={1}
                // borderRadius="20px"
                // mb={1}
              >
                <img src={feature?.icon} alt="saf" style={{width:'140px'}} />
                {/* <Typography variant="body2">{feature.label}</Typography> */}
              </Box>
              <Typography
                variant="subtitle1"
                fontWeight={600}
                color="#fff"
                sx={{ mb: 0.5 }}
              >
                {feature.title}
              </Typography>
              <Typography
                variant="body2"
                color="rgba(255,255,255,0.8)"
              >
                {feature.description}
              </Typography>
            </Box>
          ))}
        </Stack>

        <Box mt={5} textAlign="center">
          <img
            src="/Images/phoneCrop.png" // Replace with your image path
            alt="Trading UI"
            style={{
              width: "100%",
              maxWidth: "300px",
              borderRadius: "20px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default SmallComponent;
